import { render } from "./ProblemSub.vue?vue&type=template&id=50e77338&scoped=true&ts=true"
import script from "./ProblemSub.vue?vue&type=script&lang=ts"
export * from "./ProblemSub.vue?vue&type=script&lang=ts"

import "./ProblemSub.vue?vue&type=style&index=0&id=50e77338&lang=less&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50e77338"]])

export default __exports__